class MarqueeSwiper {
  constructor() {
    const swiperEls = document.querySelectorAll('.js-marquee-swiper');
    if(swiperEls.length){
      this.init(swiperEls);
    }
  }
  init(swiperEls) {
    swiperEls.forEach((item)=>{
      const wrapper = item.querySelector('.swiper-wrapper');
      wrapper.style.transitionTimingFunction = 'linear';
      const speed = item.dataset.speed ? item.dataset.speed : 10000;
      new Swiper(item,{
        loop: true,
        slidesPerView: 'auto',
        autoplay: {
          delay: 0
        },
        speed: speed
      })
    })
  }
}